import { useEffect, useState } from 'react';
import { GOODWAY_YELLOW } from '../../constants/colors';
import { stripSpecialCharacters } from '../../helpers/utils';
import CellTextField from '../atoms/CellTextField';

const AliasCell = ({
    row,
    applyRowChange,
    rowIndex,
    id,
    alias,
    name,
    field,
    default_field,
    key_field,
    labelText = 'Original Name: ',
}) => {
    const [aliasText, setAliasText] = useState(alias || name);
    const [label, setLabel] = useState();
    useEffect(() => {
        setAliasText(alias || name);
        setLabel(alias && name && `${labelText} ${name}`);
    }, [alias, name]);
    return (
        <CellTextField
            value={aliasText}
            key={id}
            placeholder={name}
            label={label}
            allowSpecialCharacters={true}
            onBlur={() => {
                if (aliasText === name && !alias) {
                    // No alias, skipping update
                    return;
                }

                const isRemoved = aliasText === name || !aliasText;

                if (aliasText === alias && !isRemoved) {
                    // Alias is the same, skipping update
                    return;
                }

                if (isRemoved) {
                    setAliasText(name);
                }

                const cleanAliasText = stripSpecialCharacters(aliasText);

                const aliasConfig = {
                    type: 'alias',
                    config: {
                        field: field,
                        key: key_field,
                        additional_filters: [
                            {
                                field: `${row.grainType}_id`,
                                key: row.grainID,
                            },
                        ],
                        default_field,
                        alias: cleanAliasText,
                    },
                };

                setAliasText(cleanAliasText);

                applyRowChange(row, aliasConfig, rowIndex, isRemoved);
            }}
            onChange={event => setAliasText(event.target.value)}
            style={{ width: '100%', label: { marginTop: '4px', color: GOODWAY_YELLOW } }}
        />
    );
};

export default AliasCell;
